import { AxiosService } from './axios.service'

/**
 * Defines the API methods for the admin ticket
 */
export class AdminTicketService {
	static baseURL = 'admin/bilhete'

	/**
	 * Get client tickets for admin
	 */
	static getTickets(orderNumber) {
		return AxiosService.get(this.baseURL, { params: { orderNumber } }).then(
			({ data }) => data.data
		)
	}

	/**
	 * Return a ticket
	 */
	static returnTicket({ ticketNumber, trackNumber }, cancelAll, isGoing) {
		return AxiosService.post(`${this.baseURL}/devolver`, {
			trackNumber,
			ticketNumber,
			cancelAll,
			isGoing,
		}).then(({ data }) => data)
	}

	/**
	 * Resend trip data to client e-mail
	 * @param {number} orderNumber
	 */
	static resendTripData(orderNumber) {
		return AxiosService.post(`${this.baseURL}/reenviar-por-email`, {
			orderNumber,
		}).then(({ data }) => data)
	}

	/**
	 * Finalize the purchase
	 * @return {Promise<any} the purchase result
	 */
	static finalizePurchase(params) {
		return AxiosService.post(`${this.baseURL}/confirmar-venda`, params).then(
			({ data }) => data
		)
	}
}
